import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import Highlighter from 'react-highlight-words'

export default function MobilePortalList({
  isAdmin = false,
  portals,
  filter = {},
  onPortalCreate,
  onPortalSelect,
  onPortalDelete,
}) {
  if (_.isEmpty(portals) && !_.isNull(filter.title)) {
    return (
      <SearchResultEmpty onPortalCreate={onPortalCreate} value={filter.title} />
    )
  }
  return _.map(portals, portal => {
    if (isAdmin) {
      return (
        <SearchResultWithDelete
          portal={portal}
          key={portal._id}
          onPortalSelect={onPortalSelect}
          onPortalDelete={onPortalDelete}
          searchText={filter.title}
        />
      )
    } else {
      return (
        <SearchResult
          portal={portal}
          key={portal._id}
          onPortalSelect={onPortalSelect}
          searchText={filter.title}
        />
      )
    }
  })
}

const SearchResultWithDelete = ({
  portal,
  onPortalSelect,
  onPortalDelete,
  searchText,
}) => {
  return (
    <a
      className="panel-block"
      key={portal._id}
      onClick={() => {
        onPortalSelect(portal)
      }}
    >
      <span
        className="panel-icon has-text-danger"
        onClick={e => {
          onPortalDelete(portal)
          e.stopPropagation() //disable parent event click
        }}
      >
        <i className="far fa-times-circle" aria-hidden="true" />
      </span>
      <Content title={_.get(portal, 'title')} searchText={searchText} />
    </a>
  )
}

const SearchResult = ({ portal, onPortalSelect, searchText }) => {
  return (
    <a
      className="panel-block"
      key={portal._id}
      onClick={() => onPortalSelect(portal)}
    >
      <Content title={_.get(portal, 'title')} searchText={searchText} />
    </a>
  )
}

const SearchResultEmpty = ({ value, onPortalCreate }) => (
  <a className="panel-block" onClick={onPortalCreate}>
    <span className="panel-icon">
      <i className="fas fa-plus" aria-hidden="true" />
    </span>
    Create Portal {value}
  </a>
)

function Content({ title, searchText }) {
  const languages = ['th', 'en', 'zh']

  console.log(title, searchText)

  return (
    <ContentStyle>
      {_.map(languages, lang => (
        <p>
          {_.get(title, lang) && (
            <span>
              <strong>{lang}:</strong>{' '}
              <Highlighter
                highlightClassName="highlight"
                searchWords={[searchText]}
                autoEscape={true}
                textToHighlight={_.get(title, lang)}
              />
            </span>
          )}
        </p>
      ))}
    </ContentStyle>
  )
}

const ContentStyle = styled.div`
  .highlight {
    background-color: #ffff00;
  }
`



// WEBPACK FOOTER //
// ./src/components/templates/mobileHome/MobilePortalList.js